/**
 * Local persistence for the high score and audio preferences.
 * Every access is guarded: private windows and blocked site data must not
 * break the game.
 */

const KEY = 'vaus.save.v1';

const DEFAULTS = {
  highScore: 0,
  sfxOn: true,
  musicOn: true,
  roundsUnlocked: 1,
};

function read() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw);
    return { ...DEFAULTS, ...parsed };
  } catch {
    return { ...DEFAULTS };
  }
}

function write(data) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    // Storage unavailable. The session still plays fine, it just forgets.
  }
}

export function createStorage() {
  let data = read();

  return {
    get all() {
      return { ...data };
    },
    get(key) {
      return data[key];
    },
    set(key, value) {
      data = { ...data, [key]: value };
      write(data);
    },
    /** Only writes when the new score actually beats the record. */
    recordScore(score) {
      if (score <= data.highScore) return false;
      this.set('highScore', score);
      return true;
    },
    unlockRound(round) {
      if (round > data.roundsUnlocked) this.set('roundsUnlocked', round);
    },
  };
}
